<label [className]="'mb-0  switch  ' + (smallSwitch ? 'switch--small' : '')">
    <div class="switch__wrapper">
        <input type="checkbox" class="switch__checkbox" (click)="onClick($event.target.checked)" [checked]="checked">
        <span class="switch__slider"></span>
    </div>
    <span class="switch__label"><ng-content></ng-content></span>
</label>
